export const PENDING_SHUTDOWN_LABEL = 'Closing soon, partner';
